import * as React from 'react';
import usePagination from '@mui/material/usePagination';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import './custompagination.css';
import PropTypes from 'prop-types';

const List = styled('ul')({
	listStyle: 'none',
	padding: 0,
	margin: 0,
	display: 'flex',
	gap: '6px',
});

export default function CustomPagination({ count, page, onChange }) {
	const { items } = usePagination({ count, page, onChange });

	function pageitem({ page, type, selected, ...item }) {
		if (type === 'start-ellipsis' || type === 'end-ellipsis') {
			return '…';
		}
		if (type === 'page') {
			return (
				<Button
					variant={selected ? 'contained' : 'outlined'}
					className='pagination-btn-small'
					{...item}
				>
					{page}
				</Button>
			);
		}
		return (
			<Button variant='outlined' className='btn-square' {...item}>
				{type}
			</Button>
		);
	}


	const pageItems = items.map(({ page, type, selected, ...item }, index) => {
		const children = pageitem({page, type, selected, ...item});
		return <li key={index}>{children}</li>;
	});

	return (
		<nav>
			<List>
				{pageItems}
			</List>
		</nav>
	);
}
CustomPagination.propTypes = {
	count: PropTypes.number.isRequired,
	page: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
  };